import { TEDrawerSection, TEInput } from '@timeedit/ui-components';
import type { OrgDrawerContentProps } from '../OrganizationDrawerContent';

type TGeneralInfoProps = {
  data: OrgDrawerContentProps['data'];
  onChangeValue: (key: string, value: string) => void;
  hasEditPermission?: boolean;
};

export const GeneralInfo = ({
  data,
  onChangeValue,
  hasEditPermission = false,
}: TGeneralInfoProps) => {
  return (
    <TEDrawerSection label="General info">
      <div className="section-item">
        <TEInput.Input
          value={data?.name}
          onChange={(e: string) => onChangeValue('name', e)}
          placeholder="Name"
          label="Name"
          tooltip="Name"
          disabled={!hasEditPermission}
        />
        <TEInput.Input
          value={data?.extId}
          onChange={(e: string) => onChangeValue('extId', e)}
          placeholder=""
          label="External Id"
          tooltip="ExtId"
          disabled={!hasEditPermission}
        />
      </div>
    </TEDrawerSection>
  );
};
